import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import VendstashLanding from "../components/landing2/VendstashLanding";

// app.tsx already scrolls these paths to the #roles section — don't fight it
// with a competing scroll-to-top on mount.
const SECTION_ROUTES = ["/for-buyers", "/for-vendors"];

const Landing = () => {
  const location = useLocation();

  useEffect(() => {
    if (SECTION_ROUTES.includes(location.pathname)) return;
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return <VendstashLanding />;
};

export default Landing;
